import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_USER_LOGOUT, CLEAR_AREA } from 'store';
import { Link } from 'react-router-dom';
import { Nav, NavDropdown, Row, Col, Button, Spinner } from 'react-bootstrap';
import { api } from 'services';
import { useTranslation } from 'react-i18next';
import './style.css';
import { Badge } from '@material-ui/core';
import { Notifications } from '@material-ui/icons';
import NotificationBell from './NotificationBell';
import { useLocation } from 'react-router-dom';

const AlertNotification = ({
  userId
}) => {
  const [notificationsOld, setNotificationsOld] = useState([]);
  const [notificationsNew, setNotificationsNew] = useState([]);
  const [hasNotification, setHasNotification] = useState(false);

  const [offset, setOffset] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  const [isLoadingMore, setLoadingMore] = useState(false);

  const [countNew, setCountNew] = useState(0);

  const [ids, setIds] = useState([]);
  const { t, i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if(userId){
      async function load(pathname){
        if(pathname == window.location.pathname){
          let element = document.getElementsByClassName('notificacao')[0];
          if(element && !element.classList.contains('show')) {
            if(await loadNotification(userId));
            setTimeout(function() {
              load(location.pathname);
            },60000)
          } else if(element){
            setTimeout(function() {
              load(location.pathname);
            },1000)
          }
        }
      }
      load(location.pathname);
    }
  }, [userId]);

  const loadNotification = async (userId, offset) => {
    let response = await api.get('notification',{params:{
      user_id:userId,
      offset:offset
    }});
    
    let data = response.data;
    if(data.message == 'ok'){
      setOffset(data.offset);
      setHasMore(data.has_more);
      data = data.data;
      setIds(data.filter(a=>a.was_viewed===0).map(a=>a.id));
      setCountNew(data.filter(a=>a.was_viewed===0).map(a=>a.id).length);
      setHasNotification(data.filter(a=>a.was_viewed===0).map(a=>a.id).length>0);
      let listnew = data.filter(a=>{
        let dif = new Date().getTime() - getObjectDate(a.created_at).getTime();
        return (dif/(1000*60*60*24)<=1) && getObjectDate(a.created_at).getDate() == new Date().getDate();
      });
      let listold = data.filter(a=>{
        let dif = new Date().getTime() - getObjectDate(a.created_at).getTime();
        return (dif/(1000*60*60*24)>1) || getObjectDate(a.created_at).getDate() != new Date().getDate();
      });

      setNotificationsNew([...listnew]);
      setNotificationsOld([...listold]);
      setLoadingMore(false);
      return true;
    }
  }

  const loadMoreNotification = (userId, offset) => {
    api.get('notification',{params:{
      user_id:userId,
      offset:offset
    }}).then(({ data }) => {
      if(data.message == 'ok'){
        setOffset(data.offset);
        setHasMore(data.has_more);
        data = data.data;
        setIds(data.filter(a=>a.was_viewed===0).map(a=>a.id));
        setNotificationsViewed(data.filter(a=>a.was_viewed===0).map(a=>a.id));
        setHasNotification(data.filter(a=>a.was_viewed===0).map(a=>a.id).length>0);
        let listnew = data.filter(a=>{
          let dif = new Date().getTime() - getObjectDate(a.created_at).getTime();
          return (dif/(1000*60*60*24)<=1) && getObjectDate(a.created_at).getDate() == new Date().getDate();
        });
        let listold = data.filter(a=>{
          let dif = new Date().getTime() - getObjectDate(a.created_at).getTime();
          return (dif/(1000*60*60*24)>1) || getObjectDate(a.created_at).getDate() != new Date().getDate();
        });
  
        setNotificationsNew([...notificationsNew,...listnew]);
        setNotificationsOld([...notificationsOld,...listold]);
        setLoadingMore(false);
      }
    });
  }

  const setNotificationRead = id => {
    api.put('notification-set-read/'+id).then(({ data }) => {
      window.location.href = data.link;
    });
    let element = document.getElementsByClassName('notificacao')[0];
    if(element)element.classList.remove('show');
    let modal = element.getElementsByClassName('dropdown-menu')[0];
    if(modal)modal.classList.remove('show');
  };

  const setAllNotificationsRead = () => {
    const getId = () => {
      let a = notificationsNew.length>0?notificationsNew[0]:null;
      let b = notificationsOld.length>0?notificationsOld[0]:null;
      if(a && b){
        if(a.id > b.id)return a.id;
        return b.id;
      }
      else if(a) return a.id;
      else if(b) return b.id;
      return null;
    }
    api.put('all-notifications-set-read/'+getId()).then(({ data }) => {
      setNotificationsNew([...notificationsNew.map(a=>{
        a.was_read = 1;
        return a;
      })]);
      setNotificationsOld([...notificationsOld.map(a=>{
        a.was_read = 1;
        return a;
      })]);
    });
  };

  const setNotificationsViewed = (ids_aux = null) => {
    if(ids_aux?ids_aux.length > 0:ids.length > 0){
      api.put('notification-set-viewed',{ids:ids}).then(({ data }) => {
        setIds([]);
        setHasNotification(false);
        setCountNew(0);
      });
    }
  };

  const getObjectDate=(date)=>{
    let aux = date.split(' ');
    let data = aux[0].split('-');
    let hora = aux[1].split(':');

    let retorno = new Date(data[0], data[1]-1, data[2], hora[0], hora[1], hora[2]);
    return new Date(retorno.setHours(retorno.getHours()-3));
  };
  
  const getTime = (date) =>{

    const calc = (d1, d2)=>{
      let dif = d1 - d2;
      // calc segundos
      dif = dif / 1000;
      if(dif < 60) return 'há pouco tempo';
      // calc minutos
      dif = dif / 60;
      if(dif < 60) return `há ${parseInt(dif)} minuto`+(parseInt(dif)>1?'s':'');
      // calc horas
      dif = dif / 60;
      if(dif < 24) return `há ${parseInt(dif)} hora`+(parseInt(dif)>1?'s':'');
      // calc dias
      dif = dif / 24;
      if(dif < 7) return `há ${parseInt(dif)} dia`+(parseInt(dif)>1?'s':'');
      // calc semanas
      dif = dif / 7;
      if(dif < 4) return `há ${parseInt(dif)} semana`+(parseInt(dif)>1?'s':'');
      // calc meses
      dif = dif / 4;
      if(dif < 12) return `há ${parseInt(dif)} `+(parseInt(dif)>1?'meses':'mês');
      // calc anos
      dif = dif / 12;
      return `há ${parseInt(dif)} ano`+(parseInt(dif)>1?'s':'');
    };
    
    let dateNotidication = getObjectDate(date);
    let dateNow = new Date();
    return calc(dateNow.getTime(), dateNotidication.getTime());
  }

  const notificationMessage = (notification) => {
    if(notification.alert.includes('Ação'))
      return t(`statuses:${notification.title}`);
    if(notification.alert.includes('Plano'))
      return t(`statuses:${notification.title}`);

    return notification.title;
  }
  
  const createNotification = (notification,k) => {
    return (
    <div className="body-notification p-2 pb-3 mb-1"
    key={k}
    style={notification.was_read===0?{background:'#ffe6d1'}:{}} 
    data-time={getTime(notification.created_at)}
    onClick={()=>setNotificationRead(notification.id)}>
      <div className="notification-title" style={notification.was_read===0?{fontWeight: 'bolder'}:{}}>{notificationMessage(notification)}</div>
      <div><a href={notification.link} className="link-notification" onClick={()=>setNotificationRead(notification.id)}>{notification.alert}</a></div>
      {notification.was_read!==0?
      <div className="viewed"></div>
      :
      <div className="viewed"><div className="not-read-circle"></div></div>
      }
    </div>
    );
  };

  const createNotificationList = (title,list) => {
    return (<div className="body-notification-group">
    <NavDropdown.Header className="title-notification-group">{title}</NavDropdown.Header>
    {list.map((n,k)=>
      createNotification(n,k)
    )}
    </div>);
  }

  // icone de notificação
  const getIcon = () => {
    return(<>
      <NotificationBell countNew={countNew}/>
      {/* <Badge badgeContent={countNew} color="primary" max={9}>
        <i className={'fas fa-bell'} style={{fontSize: 'x-large'}}></i>
      </Badge> */}
      </>
    );
  }

  return (
    <ul className="list-unstyled float-right mb-0">
      <Nav className="mr-auto" id="notificacao">
        <NavDropdown className="nav-text-white notificacao" title={getIcon()} onClick={(e)=>{
          setNotificationsViewed();
          }}>
          <div id="area-notification" onScroll={(e)=>{
            let element = e.target;

            if(element.scrollHeight <= (element.clientHeight + element.scrollTop)+40){
              if(hasMore && !isLoadingMore){
                setLoadingMore(true);
                loadMoreNotification(userId,offset);
              }
            }
          }}>
            <NavDropdown.Header className="title-notification p-3" style={{fontWeight: 'bolder'}}>
            <Notifications style={{color:'white'}} className="mr-2"/>
              Notificações
            </NavDropdown.Header>
            {([...notificationsNew,...notificationsOld]).length>0?(
                <div className="read-all col-12" onClick={setAllNotificationsRead}>
                  <span>Marcar todos como lidos</span>
                </div>
              ):''}
            <div className="list-notifications">
              {notificationsNew.length>0?createNotificationList('Hoje',notificationsNew):''}
              {notificationsOld.length>0?createNotificationList('Mais antigo',notificationsOld):''}
            </div>
            {([...notificationsNew,...notificationsOld]).length==0?(
              <div style={{
                padding: '10px',
                textAlign: 'center'
              }}>Você ainda não possui notificações</div>
            ):''}
          </div>
        </NavDropdown>
      </Nav>
    </ul>
  );
};

export default AlertNotification;
